/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state } = store( 'clientar-blocks', {
	state: {},
	actions: {
		openMenuModal() {
			state.isMenuModalOpen = ! state.isMenuModalOpen;
		}
	},
	callbacks: {
		menuStatus() {
			console.log(`estado do menu: ${state.isMenuModalOpen}`)
		}
	},
} );
